export default __webpack_public_path__ + "static/media/MdroDetailLabel.4cecfc1d.svg";